module.exports = "/subscriptions/assets/de505cccb50fc1e44b12c27d647a2f12.png";